import { Notification } from 'store/notifications/types';
import { createAction } from 'typesafe-actions';

export const showNotification = createAction('SHOW_NOTIFICATION')<Notification>();
export const hideNotification = createAction('HIDE_NOTIFICATION')<void>();
